import { http } from '@/api/http';

/**
 * Transport for the generic template merge-field catalog (PTV2-1162):
 * GET /api/v1/template-variables/{context}. One endpoint serves every document/template feature;
 * the {@code context} selects the curated variable set.
 */

export type TemplateVariableGroup = 'PATIENT' | 'QUESTIONNAIRE' | 'CLINIC';
export type TemplateVariableDataType = 'STRING' | 'URL' | 'DATE';

/** Authoring contexts known to the UI (mirrors the backend enum). */
export type TemplateVariableContext = 'PPQ_EMAIL';

export interface TemplateVariableDto {
  key: string;
  label: string;
  description: string;
  group: TemplateVariableGroup;
  data_type: TemplateVariableDataType;
}

export const templateVariablesEndpoints = {
  getTemplateVariables: (
    context: TemplateVariableContext,
    options?: { signal?: AbortSignal },
  ): Promise<TemplateVariableDto[]> =>
    http.get<TemplateVariableDto[]>(`/template-variables/${encodeURIComponent(context)}`, options),
};
